module.exports = __webpack_public_path__ + "9b617ed399236ad859cd0bf6e927bc89.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/chloe/victory2.png
// module id = 42
// module chunks = 0